<template>
    <div>
        <div class="text-md-h2 text-h3 font-weight-bold" v-html="$t('whitelabel.investment.title')"></div>
        <div class="text-h5 py-6 my-0 grey--text" v-html="$t('whitelabel.investment.subtitle')"></div>
        <v-divider></v-divider>
        <div class="text-h5 pt-6 my-0 grey--text" v-html="$t('whitelabel.investment.description')"></div>
        <v-row>
            <v-col cols="12" md="4" sm="12" v-for="(card, index) in $t('whitelabel.investment.cards')" :key="index">
                <v-card elevation="0" color="#E7EBF5" class="mt-6" style="height:100%">
                    <v-card-title>
                        <div class="primary--text text-h5 font-weight-bold">
                            <v-img width="42" class="my-9" :src="card.img"></v-img>
                        {{ card.title }}
                      </div>
                    </v-card-title>
                    <v-card-text class="pt-3">
                        <template  v-for="(item, i) in card.list">
                            <div :key="`i_${i}`" class="py-3 black--text" style="font-size: 1.05rem" v-html="item"></div>
                            <v-divider v-if="i < card.list.length - 1" :key="`s_${i}`"></v-divider>
                        </template>
                    </v-card-text>
                  </v-card>
            </v-col>
            
           
            <v-col cols="12" md="4" sm="12">
                <v-card 
                    v-if="!hasSigned"
                    elevation="0" 
                    color="primary" 
                    class="mt-6 d-flex align-center justify-center" 
                    style="height:100%" 
                    to="/cadastrar?isWhitelabel=1">
                    <div class="text-h4 white--text font-weight-bold">
                        {{ $t('whitelabel.investment.cta') }}<br><v-icon color="white" large>mdi-arrow-right</v-icon>
                    </div>
                </v-card>
                
                <a 
                    v-else
                    href="https://calendly.com/themediatrade-maggi" 
                    target="_blank" 
                    style="text-decoration: none;">
                    <v-card elevation="0" color="primary" class="mt-6 d-flex align-center justify-center" style="height:100%">
                        <div style="width: 75%;" class="text-h4 white--text font-weight-bold">
                            Solicitar uma proposta<br><v-icon color="white" large>mdi-arrow-right</v-icon>
                        </div>
                    </v-card>
                </a>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
  name: 'WhitelabelInvestiment',
  computed: {
    hasSigned() {
      return this.$route.query.signed !== undefined;
    }
  }
}
</script>

<style scoped>
@media (max-width: 500px) {
  .text-h3 {
    font-size: 1.75rem !important;
  }
  
  .text-h5 {
    font-size: 1.25rem !important;
  }
  
  .text-h4 {
    font-size: 1.5rem !important;
  }
}
</style>